import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

const inputStyles = {
    mx: 1,
    minWidth: { xs: '80px', sm: '120px', md: '140px' },
    maxWidth: { xs: '150px', sm: '220px', md: '260px' },
    verticalAlign: 'middle',
    '& .MuiInputBase-root': {
        fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.8rem' },
        fontWeight: 'bold',
        backgroundColor: 'transparent',
    },
};

const primaryColorInput = {
    ...inputStyles,
    '& .MuiInputBase-input': { color: 'primary.main', textAlign: 'center' },
    '& .MuiInput-underline:before': { borderBottomColor: 'primary.main', borderBottomWidth: '2px' },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'primary.main', borderBottomWidth: '2px' },
    '& .MuiInput-underline:after': { borderBottomColor: 'primary.main', borderBottomWidth: '2px' },
};

const secondaryColorInput = {
    ...inputStyles,
    '& .MuiInputBase-input': { color: 'secondary.main', textAlign: 'center' },
    '& .MuiInput-underline:before': { borderBottomColor: 'secondary.main', borderBottomWidth: '2px' },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottomColor: 'secondary.main', borderBottomWidth: '2px' },
    '& .MuiInput-underline:after': { borderBottomColor: 'secondary.main', borderBottomWidth: '2px' },
};

const ModernStockForm = ({ formData, handleInputChange, handleAddOrEditRow, handleReset, editingIndex }) => {
    return (
        <Box component="form" onSubmit={handleAddOrEditRow} noValidate sx={{ width: '100%' }}>
            <Paper elevation={3} sx={{ p: { xs: 2, sm: 4 }, mb: 3, borderRadius: 2 }}>
                <Typography component="div" sx={{ 
                    lineHeight: { xs: 3, sm: 3.5 }, 
                    display: 'inline',
                    fontWeight: 'medium',
                    fontSize: { xs: '1.25rem', sm: '1.5rem', md: '1.8rem' }
                }}>
                    I want to Invest in
                    <TextField
                        variant="standard"
                        placeholder="Stock Name"
                        name="stockName"
                        value={formData.stockName}
                        onChange={handleInputChange}
                        sx={primaryColorInput}
                    />
                    with
                    <TextField
                        variant="standard"
                        type="number"
                        placeholder="New Amount"
                        name="newAmount"
                        value={formData.newAmount}
                        onChange={handleInputChange}
                        sx={secondaryColorInput}
                    />
                    at
                    <TextField
                        variant="standard"
                        type="number"
                        placeholder="Current Price"
                        name="currPrice"
                        value={formData.currPrice}
                        onChange={handleInputChange}
                        sx={secondaryColorInput}
                    />
                    . I already have
                    <TextField
                        variant="standard"
                        type="number"
                        placeholder="Holding Units"
                        name="holdUnit"
                        value={formData.holdUnit}
                        onChange={handleInputChange}
                        sx={primaryColorInput}
                    />
                    at
                    <TextField
                        variant="standard"
                        type="number"
                        placeholder="Average Price"
                        name="avgPrice"
                        value={formData.avgPrice}
                        onChange={handleInputChange}
                        sx={primaryColorInput}
                    />
                    .
                </Typography>
                
                <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button variant="contained" color="primary" type="submit" size="large">
                        {editingIndex !== null ? 'Update' : 'Evaluate'}
                    </Button>
                    <Button variant="outlined" color="primary" onClick={handleReset} size="large">
                        Reset
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
};

export default ModernStockForm;
